import { GateArrivalsFilterDto } from '../models/dto/arrival/gate-arrivals-filter.dto';
import { HttpParams } from '@angular/common/http';

export const buildParams = (filter: GateArrivalsFilterDto): HttpParams => {
  let params = new HttpParams();
  params =
    filter.page != undefined
      ? params.set('page', filter.page!.toString())
      : params;
  params =
    filter.limit != undefined
      ? params.set('limit', filter.limit!.toString())
      : params;
  params =
    filter.sortByDate != undefined
      ? params.set('sortByDate', filter.sortByDate.toString())
      : params;
  params =
    filter.name != undefined && filter.name != ''
      ? params.set('name', filter.name)
      : params;
  params =
    filter.hasAuthorization != undefined
      ? params.set('hasAuthorization', filter.hasAuthorization.toString())
      : params;
  params =
    filter.length != undefined
      ? params.set('length', filter.length.toString())
      : params;
  params =
    filter.status != undefined
      ? params.set('status', filter.status.join(','))
      : params;
  params =
    filter.currentDate != undefined
      ? params.set('currentDate', filter.currentDate.toString())
      : params;
  return params;
};
